import { IconUsersGroup } from "@tabler/icons-react";
import styles from "../../pages/ClientDashboard/TeamManagement/teamManagement.module.css";

export default function TeamHero({ totalUsers, totalTeams, admins, pending }) {
  return (
    <div className={styles.teamHero}>
      <div className={styles.heroIcon}>
        <IconUsersGroup size={30} />
      </div>
      <div className={styles.heroText}>
        <h2>Manage your team</h2>
        <p>
          Control who has access, assign roles, and organise members into teams.
        </p>
      </div>
      <div className={styles.heroStats}>
        <div className={styles.heroStat}>
          <div className={styles.heroStatValue}>{totalUsers}</div>
          <div className={styles.heroStatLabel}>Total Users</div>
        </div>
        <div className={styles.heroStat}>
          <div className={styles.heroStatValue}>{totalTeams}</div>
          <div className={styles.heroStatLabel}>Teams</div>
        </div>
        <div className={styles.heroStat}>
          <div className={styles.heroStatValue}>{admins}</div>
          <div className={styles.heroStatLabel}>Admins</div>
        </div>
        <div className={styles.heroStat}>
          <div className={styles.heroStatValue}>{pending}</div>
          <div className={styles.heroStatLabel}>Pending</div>
        </div>
      </div>
    </div>
  );
}
